import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  private apiURL: string = '';
  private apiURLZA: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
    this.apiURLZA = this.appConfig.getEnvironmentZA();
  }

  getAllProducts(partnerID: string) {
    var partner = this.helpersService.getPartnerData();
    console.log(partner);
    if (
      partner.posSystemID <= 2 ||
      partner.posSystemID == 5 ||
      partner.posSystemID == 7
    ) {
      let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
      return this.http
        .get(
          this.apiURLZA + '/api/Partner/' + partnerID + '/POSProducts_v2/false',
          requestOptions,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            return throwError(res);
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .get(
          this.appConfig.getPOSEnvironment().url +
          `/${partnerID}/products/sync/incremental/immediate`,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: any) => {
            return throwError(error);
          }),
        );
    }
  }

  getAllProductsWithGear(partnerID: string) {
    var partner = this.helpersService.getPartnerData();
    console.log(partner);
    if (
      partner.posSystemID <= 2 ||
      partner.posSystemID == 5 ||
      partner.posSystemID == 7
    ) {
      let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
      return this.http
        .get(
          this.apiURLZA + '/api/Partner/' + partnerID + '/POSProducts_v2',
          requestOptions,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((res: any) => {
            return throwError(res);
          }),
        );
    } else {
      var headers = this.helpersService.getPOSApiHeaders(
        this.appConfig.getPOSEnvironment().key,
      );
      return this.http
        .get(
          this.appConfig.getPOSEnvironment().url +
          `/${partnerID}/products/sync/incremental/immediate`,
          headers,
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: any) => {
            return throwError(error);
          }),
        );
    }
  }

  syncNewProducts(partnerID: string) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url +
        `/${partnerID}/products/sync/incremental/immediate`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        }),
      );
  }

  searchInvoiceProduct(partnerID: string, SKU: string) {
    let body = {
      PartnerID: partnerID,
      SKU: SKU,
      Name: null,
      Type: null,
      Brand: null,
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/Invoice/SearchForProduct', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchProduct(partnerID: string, searchTerm: string) {
    let body = { ID: partnerID, SKU: searchTerm };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/lstSKUAutocompleteLookupV2',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res.products;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  searchProductV2(partnerID: string, searchTerm: string) {
    let body = { ID: partnerID, SKU: searchTerm };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/lstSKUAutocompleteLookupV2',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  searchExternalProduct(partnerID: string, searchTerm: string) {
    let body = { ID: partnerID, SKU: searchTerm };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Partner/lstExternalSKUAutocompleteLookup',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getQtyPerProduct(partnerID: string, externalProductID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        `/api/Partner/quantityInStockForProduct/${partnerID}/${externalProductID}`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  GetInventoryOnHandForProducts(partnerID: string, data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Invoice/' + partnerID + '/GetInventoryOnHand',
        data,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  /*Product Management*/
  getSingleProduct(productID) {
    let headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/ProductManagement/${productID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateSingleProduct(data) {
    let headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/ProductManagement?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  createSingleProduct(data) {
    let headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/ProductManagement?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteSingleProduct(productID) {
    let headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/ProductManagement/${productID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  checkSKUExists(data) {
    let headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/ProductManagement/CheckIfSKUExists?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  importProducts(data) {
    let headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/ProductManagement/Import?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  removePOSProducts(partnerID, data) {
    let headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Partner/${partnerID}/RemoveProducts?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  createPOSSKU(partnerID: number, data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + `/api/Partner/${partnerID}/CreatePOSSKU`, data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

   //TREK 1.18 FEATURE START
  getProductCollections(partnerID: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/ProductCollections?code=${this.env.key}`, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
  getProductCollectionData(partnerID: string, productCollectionID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/ProductCollectionData/${productCollectionID}?code=${this.env.key}`, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
  addProductCollection(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/ProductCollection/Create?code=${this.env.key}`, data, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
  addProductCollectionLink(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Bikeshop/ProductCollections/LinkProduct?code=${this.env.key}`, data, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
  deleteProductCollectionLink(partnerID: string, productCollectionLinkID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/Bikeshop/Partner/${partnerID}/ProductCollections/DeleteLinkedProduct/${productCollectionLinkID}?code=${this.env.key}`, headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
  saveProductLabour(productID: number, markedAsLabourProduct: boolean) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/Bikeshop/ProductManagement/${productID}/Labour?code=${this.env.key}`,
        { MarkedAsLabourProduct: markedAsLabourProduct },
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
  
  //TREK 1.18 FEATURE END
}
